import React, { useState } from "react";
import * as moment from "moment";
import UserDefaultAvatar from "assets/img/user.svg";
import ConvertSvgToComponent from "components/ConvertSvgToComponent";
import { useUserContext } from "store/contexts/userContext";
import { useHistory } from "react-router-dom";
import ShowAllRecognizedMembers from "components/ShowAllRecognizedMembers";
import LazyLoadImage from "components/LazyLoadImage";
import SummerizerSummary from "components/AI-Assistant/SummerizerSummary/SummerizerSummary";
import PostSummarizer from "components/AI-Assistant/Summerizer/PostSummarizer";
import { useTimelineContext } from "store/contexts/timelineContext";
import { useMoodsContext } from "store/contexts/moodsContext";

export default ({ post, color }) => {
	let history = useHistory();
	const { moods } = useMoodsContext();
	const { user } = useUserContext();
	const [countUserTag] = useState(post?.data?.tagged_users?.length);
	const [todoListItemShared] = useState(
		post?.type_id === 17 ? post?.data?.is_forwarded : false
	);
	const [todoListShared] = useState(
		post?.type_id === 16 ? post?.data?.is_forwarded : false
	);
	const [timeDifference] = useState(moment(post.created_at).fromNow());
	const [postMessage] = useState({
		text: "Created a status",
		celebration: "Posted a Wall of Fame",
		brightidea: "Shared an Idea/Accouncement",
		checkin: "Initiated a check-in request",
		"checkin.reply": "Changed mood to ",
		topic: "Posted a new topic",
		welcomemessage: "Posted a welcome message",
		watercooler: "Started Watercooler",
		coursecreation: "Created a Course",
		survey: "Created a Survey"
	});
	const { innovation_dashboard } = useTimelineContext();

	let postDescriptor = postMessage[post.type];
	let moodIcon = null;

	if (post?.type === "teamvideo") {
		switch (post?.data?.published) {
			case true:
				postDescriptor = "Published a Team Video";
				break;

			default:
				postDescriptor = "Initiated a Team Video";
				break;
		}
	}

	if (post?.type === "slideshow") {
		switch (post?.data?.published) {
			case true:
				postDescriptor = "Published a Slide Show";
				break;

			default:
				postDescriptor = "Initiated a Slide Show";
				break;
		}
	}

	if (post?.type === "celebration" && countUserTag !== 0) {
		switch (
		post?.data?.tagged_users.some((taguser) => taguser?.id === user?.id)
		) {
			case true:
				postDescriptor = "Recognized You";
				postDescriptor = tagUserLength(postDescriptor, true);
				break;

			default:
				postDescriptor = `Recognized ${post?.data?.tagged_users[0]?.full_name}`;
				postDescriptor = tagUserLength(postDescriptor, false);
				break;
		}
	}

	if (post.type === "checkin.reply") {
		postDescriptor = `${postDescriptor}${post?.data?.mood?.name}`;
		let moodData = moods?.find(mood => mood.id === post?.data?.mood?.id);
		moodIcon = moodData?.media;
	}

	if (post.type === "poll") {
		postDescriptor = "Created a Poll";
	}

	if (post.type === "todo-list") {
		postDescriptor = "Created a List";
	}

	if (post.type === "todo-list-item") {
		postDescriptor = "Created a Todo List Item";
	}

	function tagUserLength(postDescriptor, userInclude) {
		if (countUserTag - 1 === 0) {
			let result = postDescriptor;
			return result;
		}

		if (userInclude) {
			let result = postDescriptor + ` and ${countUserTag - 1} other`;
			return result;
		}

		if (!userInclude) {
			let result = postDescriptor + ` and ${countUserTag - 1} other`;
			return result;
		}
		return;
	}

	const showUserProfile = (id) => {
		history.push(`/profile/${id}`);
	};

	const allowSummarizer = () => {
		if (["text", "brightidea"].includes(post?.type)) {
			return post?.type === "text"
				? post?.data?.content?.length >= 50
				: post?.data?.text?.length >= 50;
		}
		return false;
	};

	return (
		<div className="post-header">
			<div className="img_user">
				<span style={{ position: "relative" }}>
					{!post?.is_forwarded && !todoListItemShared && !todoListShared && (
						<LazyLoadImage
							style={{ cursor: "pointer" }}
							onClickFunction={() => showUserProfile(post?.user?.id)}
							imageClassName="userAvatar"
							image={post?.user?.avatar ?? UserDefaultAvatar}
							key={`${post?.user?.full_name || post?.user?.name}`}
							alt={`${post?.user?.full_name || post?.user?.name}`}
						/>
					)}
					{(post?.is_forwarded || todoListItemShared || todoListShared) && (
						<img
							style={{ cursor: "pointer" }}
							onClick={() =>
								showUserProfile(
									post?.data?.original_todoList_item?.user?.id ??
									post?.data?.original_todoList?.user?.id ??
									post?.original_post?.user?.id
								)
							}
							className="userAvatar"
							src={
								post?.data?.original_todoList_item?.user?.avatar ??
								post?.data?.original_todoList?.user?.avatar ??
								post?.original_post?.user?.avatar ??
								UserDefaultAvatar
							}
							alt={`${post?.data?.original_todoList_item?.user?.full_name ??
								post?.data?.original_todoList?.user?.full_name ??
								post?.original_post?.user?.full_name
								}`}
						/>
					)}
					{!!moodIcon && (
						<LazyLoadImage
							image={moodIcon}
							key={postDescriptor}
							alt={postDescriptor}
							imageClassName={"moodAvatar"}
							imageWrapperClassName={"moodAvatar"}
						/>
					)}
				</span>
				<div className="userInformation">
					<span>
						{!post?.is_forwarded && !todoListItemShared && !todoListShared && (
							<span className="post_uname">{post?.user?.full_name || post?.user?.name}</span>
						)}
						{(post?.is_forwarded || todoListItemShared || todoListShared) && (
							<span className="post_uname">
								{post?.data?.original_todoList_item?.user?.full_name ??
									post?.data?.original_todoList?.user?.full_name ??
									post?.original_post?.user?.full_name}
							</span>
						)}
						{post?.data?.tagged_user && (
							<span className="userRecognized">
								{" "}
								has recognized {post.data.tagged_user.full_name}
							</span>
						)}
					</span>
					<span className="post_time">Posted {timeDifference}</span>
					{innovation_dashboard && (
						<span className="post_time_submitted">
							Shared by {post?.user?.full_name}{" "}
							{post?.user?.first_name !== "Anonymous" &&
								`from ${post?.original_post?.team?.name}`}
						</span>
					)}
					{post?.team && (
						<span className="post_team">
							<span>Team Name:</span>
							<span>{post?.team?.name}</span>
						</span>
					)}
					<ShowAllRecognizedMembers
						description={postDescriptor}
						tagged_users={post?.data?.tagged_users}
						countUserTag={countUserTag}
					/>
					{(post?.is_forwarded || todoListItemShared || todoListShared) && (
						<div className="sharedText">
							<LazyLoadImage
								style={{ cursor: "pointer" }}
								onClickFunction={() => showUserProfile(post?.user?.id)}
								image={post?.user?.avatar ?? UserDefaultAvatar}
								key={`${post?.user?.full_name}`}
								alt={`${post?.user?.full_name}`}
								imageClassName={"sharedImg"}
							/>
							<span style={{ paddingLeft: "1px" }}>
								Shared By {post?.user?.full_name ?? "undefined"}
								{post?.user?.first_name !== "Anonymous" &&
									` from 
                ${post?.original_post?.team?.name ??
									post?.data?.original_todoList_item?.team?.name ??
									post?.data?.original_todoList?.team?.name ??
									"undefined"
									}`}
							</span>
						</div>
					)}
					{(post?.type === "teamvideo" || post?.type === "slideshow") && (
						<span>Topic: {post?.data.topic}</span>
					)}
					{["brightidea", "text"].includes(post?.type) && post.data.summary && (
						<SummerizerSummary data={post?.data?.summary} />
					)}
					{!innovation_dashboard && ["brightidea", "text"].includes(post?.type) &&
						!post.data.summary &&
						allowSummarizer() && (
							<PostSummarizer
								data={post}
								type={post?.type}
								isInnovationDashboard={innovation_dashboard}
							/>
						)}
				</div>
			</div>
			{post?.type !== "text" && post?.type !== "checkin.reply" && (
				<div className="p-h-right">
					<ConvertSvgToComponent
						watercooler_private={post?.is_private}
						icon={post?.type}
						color={color}
						imageclass="postClass"
					/>
				</div>
			)}
		</div>
	);
};
